module.exports = __webpack_public_path__ + "static/bg-banner-05614ec7a2856cdc8bf31ca78c51d1cb.jpg";